import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { router } from './channel.routes';
import { AuthGuard } from '../auth/auth.guard';
import { CommonModule } from '@angular/common';
import { TabsModule } from '../tabs/tabs.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
import { RatingModule } from 'ngx-bootstrap/rating';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PreviewModule } from '../preview/preview.module';
import { SharedModule } from '../shared/shared.module';
import { ConfigureChannelComponent } from './configure/configure.component';
import { ClipboardModule } from 'ngx-clipboard';
import { InputTrimModule } from 'ng2-trim-directive';
import { TagInputModule } from 'ngx-chips';

@NgModule({
  declarations: [ConfigureChannelComponent],
  exports: [],
  entryComponents: [],
  imports: [
    TagInputModule,
    HttpModule,
    ClipboardModule,
    CommonModule,
    router,
    BrowserModule,
    SharedModule,
    TabsModule,
    FormsModule,
    ModalModule,
    PreviewModule,
    TranslateModule,
    ReactiveFormsModule,
    InputTrimModule,
    RatingModule.forRoot()
  ],
  providers: [AuthGuard]
})
export class ChannelModule {}



// WEBPACK FOOTER //
// ./src/app/modules/channel/channel.module.ts